import { render, staticRenderFns } from "./top-pop.vue?vue&type=template&id=352ba950&scoped=true&"
import script from "./top-pop.vue?vue&type=script&lang=js&"
export * from "./top-pop.vue?vue&type=script&lang=js&"
import style0 from "./top-pop.vue?vue&type=style&index=0&id=352ba950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ba950",
  null
  
)

export default component.exports